import React, { useMemo } from 'react'
import { ComposedChart, Line, Area, ResponsiveContainer } from 'recharts'
import { EmptyState } from 'shared/ui'

export const OverallLineChart = ({ data }: { data: number[] }) => {
  const chartData = useMemo(() => {
    return data.map((value, index) => ({
      value,
      index,
    }))
  }, [data])

  if (!chartData.length) return <EmptyState text={'No data'} boxProps={{ height: 60 }} noIcon />

  return (
    <ResponsiveContainer width='100%' height={60}>
      <ComposedChart data={chartData} margin={{ top: 5, right: 5, bottom: 5, left: 5 }}>
        <defs>
          <linearGradient id='trendGradient' x1='0' y1='0' x2='0' y2='1'>
            <stop offset='0%' stopColor='var(--content-brand-primary)' stopOpacity={0.3} />
            <stop offset='100%' stopColor='var(--content-brand-primary)' stopOpacity={0.05} />
          </linearGradient>
        </defs>
        <Area
          type='monotone'
          dataKey='value'
          stroke='var(--content-brand-primary)'
          fill='url(#trendGradient)'
          strokeWidth={0}
          tooltipType='none'
        />
        <Line
          type='monotone'
          dataKey='value'
          stroke='var(--content-brand-primary)'
          strokeWidth={2}
          dot={false}
          activeDot={{ r: 3, fill: 'var(--content-brand-primary)' }}
        />
      </ComposedChart>
    </ResponsiveContainer>
  )
}
